// Auto-import SASS generated CSS
import './index.css';

export type {TabGroupProps, TabGroupTabModel} from './TabGroup';
export {default as default} from './TabGroup';
